import * as React from "react";
import "./styles.scss";
import { Button, Modal, Image } from "semantic-ui-react";
import EmailPreview from "./emailPreview.png";

interface SendNotificationConfirmationProps {
  open: boolean;
  playerName: string;
  onClose: (sendNotification: boolean | undefined) => void;
}

const SendNotificationConfirmation: React.FC<SendNotificationConfirmationProps> = ({ open, playerName, onClose }) => {
  return (
    <Modal open={open} size="tiny" className="sendNotificationConfirmation">
      <Modal.Header>Send Update Notification to Players?</Modal.Header>
      <Modal.Content>
        <strong>Would you like to notify {playerName} about their Player Card updates?</strong>
        <Image src={EmailPreview} className="emailPreviewImage" />
      </Modal.Content>
      <Modal.Actions>
        <Button secondary content="Cancel" onClick={() => onClose(undefined)} />
        <div className="grow" />
        <Button secondary content="No" onClick={() => onClose(false)} />
        <Button primary content="Yes" onClick={() => onClose(true)} />
      </Modal.Actions>
    </Modal>
  );
};
export default SendNotificationConfirmation;
